<form novalidate #propertyRentalRentiSectionForm="ngForm">
    <tg-row *ngIf="draftLoaded$ | async" class="property-rental-renti-section">
        <tg-col md="9" sm="12">
            <tg-row>
                <tg-col md="8" sm="12">
                    <tg-radio-group
                        label="Would you like to receive digital tenancy application forms?"
                        class="
                            property-rental-renti-section__renti-selection-group
                        "
                        ngModel
                        name="renti-selection-radio-group"
                        (change)="publish()"
                        [(ngModel)]="
                            draftData.propertyInformation.isRentiAccepted
                        "
                        [validation]="
                            validation.propertyInformation.isRentiAccepted
                                | toValidator
                        "
                    >
                        <tg-radio-item
                            [value]="true"
                            label="Yes"
                            class="property-rental-renti-section__renti-option"
                        >
                        </tg-radio-item>
                        <tg-radio-item
                            [value]="false"
                            label="No"
                            class="property-rental-renti-section__renti-option"
                        >
                        </tg-radio-item>
                    </tg-radio-group>
                </tg-col>
            </tg-row>
            <tg-row>
                <tg-col sm="12" md="8" lg="8">
                    <p class="p-secondary-copy">
                        This will enable people to apply online. We will share
                        your email address with our partner Renti to allow them
                        to send you digital application forms.
                        <a
                          class="h-link-no-visited"
                          target="_blank"
                          href="https://www.trademe.co.nz/c/property/article/trade-me-renti-partnership-cuts-through-admin-for-landlords"
                        >
                          Learn more
                        </a>
                    </p>
                </tg-col>
            </tg-row>
        </tg-col>
    </tg-row>
</form>
